export default __webpack_public_path__ + "static/media/fire.ed2fc61e.gif";